var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 100,
    viewBox: "0 0 90 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6654 86.577C57.6654 93.6537 51.8778 99.4676 44.8012 99.4676C37.6456 99.4676 31.858 93.68 31.858 86.5244C31.8843 79.4478 37.6719 73.6865 44.7749 73.7128C51.8778 73.6865 57.6654 79.4741 57.6654 86.577ZM35.962 91.2597C38.3033 88.6553 41.1971 87.1821 44.7223 87.1558C48.2737 87.1295 51.1938 88.6553 53.5878 91.2597C55.9554 87.3925 54.8768 81.8417 51.2464 78.8164C47.3793 75.5806 41.5654 75.7122 37.9087 79.1321C34.4888 82.3153 33.568 87.8398 35.962 91.2597Z",
    fill: "url(#paint0_linear_1325_202)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6654 12.9695C57.6391 20.0198 51.8252 25.8074 44.7223 25.7811C37.6456 25.7548 31.858 19.9672 31.858 12.8905C31.858 5.76128 37.6719 0 44.8538 0C51.9304 0.0263072 57.6654 5.8402 57.6654 12.9695ZM35.962 17.5995C38.277 14.9425 41.2234 13.4956 44.7223 13.4956C48.2737 13.4693 51.2464 14.9425 53.5878 17.6258C55.9554 13.8376 54.9295 8.26046 51.378 5.26144C47.4845 1.94673 41.8285 1.99935 38.0402 5.36667C34.5414 8.41831 33.568 14.0217 35.962 17.5995Z",
    fill: "url(#paint1_linear_1325_202)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4971 68.2146C89.4971 75.3438 83.7622 81.0525 76.6329 81.0525C69.5563 81.0525 63.7687 75.2649 63.7424 68.162C63.7161 61.059 69.5826 55.2451 76.7381 55.2715C83.8674 55.2978 89.5234 61.0327 89.4971 68.2146ZM85.5247 72.7131C87.9187 69.1617 86.7875 63.7687 83.6306 60.7697C79.9213 57.2708 74.1337 57.0866 70.1087 60.4277C66.5309 63.4004 65.4523 69.109 67.7937 72.7657C72.529 67.6358 80.1581 67.1623 85.5247 72.7131Z",
    fill: "url(#paint2_linear_1325_202)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 68.1094C0 60.9801 5.70866 55.2715 12.8642 55.2715C19.9409 55.2715 25.7548 61.0853 25.7548 68.1357C25.7548 75.2649 19.9409 81.0525 12.759 81.0525C5.68236 81.0262 0 75.2649 0 68.1094ZM3.97239 72.792C8.91815 67.5043 16.6262 67.2675 21.7824 72.792C24.0448 69.0038 23.0451 63.5056 19.5463 60.5066C15.7317 57.2445 10.1809 57.1919 6.41896 60.375C2.68333 63.4793 1.63105 68.8197 3.97239 72.792Z",
    fill: "url(#paint3_linear_1325_202)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4971 31.3582C89.4971 38.4874 83.7622 44.1961 76.6329 44.1961C69.5563 44.1961 63.7424 38.3822 63.7424 31.3319C63.7424 24.2026 69.5826 18.3887 76.7381 18.415C83.8674 18.4414 89.5234 24.1763 89.4971 31.3582ZM85.5774 35.962C87.8924 31.8843 86.7875 26.4651 83.0519 23.4397C79.211 20.3355 73.6602 20.467 69.9246 23.7554C66.5046 26.7807 65.5313 32.2789 67.7937 35.9356C72.7657 30.5953 80.3685 30.4901 85.5774 35.962Z",
    fill: "url(#paint4_linear_1325_202)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.2267C0 24.0974 5.76128 18.415 12.8905 18.415C19.9672 18.4414 25.7548 24.2552 25.7548 31.3056C25.7548 38.4085 19.8883 44.2224 12.7327 44.1698C5.65605 44.1698 0 38.4085 0 31.2267ZM21.7561 35.9883C24.2026 31.6476 22.861 26.0441 18.757 23.0714C14.5742 20.0461 8.81291 20.7038 5.31406 24.5709C2.60441 27.57 1.73628 32.7262 4.07762 35.9093C8.94445 30.6479 16.5209 30.4374 21.7561 35.9883Z",
    fill: "url(#paint5_linear_1325_202)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8275 36.8301C51.9041 36.8564 57.6654 42.6703 57.6654 49.7469C57.6654 56.8762 51.7989 62.6638 44.6433 62.6375C37.593 62.6112 31.858 56.7446 31.858 49.6417C31.8843 42.5914 37.7245 36.8038 44.8275 36.8301ZM44.6959 39.6713C39.0399 39.6976 34.6466 44.1435 34.6729 49.7995C34.6992 55.4556 39.1451 59.8489 44.8012 59.8226C50.4572 59.7963 54.8505 55.3504 54.8242 49.6943C54.7979 44.012 50.352 39.6187 44.6959 39.6713Z",
    fill: "url(#paint6_linear_1325_202)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9373 43.4332C29.201 42.3283 27.5436 41.3549 26.0178 40.2237C25.7811 40.0659 25.86 39.0662 26.1494 38.7242C26.4124 38.3822 27.2543 38.1455 27.5963 38.3296C29.0958 39.0399 30.5164 39.8817 31.8843 40.8288C32.2 41.0392 32.3579 41.8811 32.2263 42.3283C32.0948 42.7229 31.4897 42.986 30.9373 43.4332Z",
    fill: "url(#paint7_linear_1325_202)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5072 43.4858C57.9548 42.986 57.376 42.7229 57.2708 42.3283C57.1656 41.8811 57.2971 41.0655 57.6128 40.8288C58.9808 39.8817 60.4277 39.0662 61.9272 38.3296C62.2955 38.1454 63.0847 38.4085 63.4004 38.7505C63.6634 39.0399 63.795 40.0133 63.5845 40.1448C61.9798 41.276 60.2698 42.3283 58.5072 43.4858Z",
    fill: "url(#paint8_linear_1325_202)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0162 55.9817C31.5686 56.4816 32.1474 56.7973 32.2789 57.2182C32.3842 57.6654 32.1737 58.4546 31.8317 58.6914C30.4901 59.6121 29.0958 60.4277 27.6489 61.1116C27.2806 61.2958 26.4651 61.0853 26.1757 60.7697C25.8863 60.454 25.7811 59.428 25.9915 59.2701C27.57 58.1389 29.2273 57.1393 31.0162 55.9817Z",
    fill: "url(#paint9_linear_1325_202)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7424 59.7174C63.7161 60.9538 62.7427 61.5852 61.7956 61.1116C60.4014 60.4014 59.0071 59.6121 57.7443 58.7177C57.376 58.4546 57.113 57.5076 57.3234 57.1656C57.5865 56.7446 58.5072 56.2448 58.8755 56.4027C60.454 57.1393 61.9272 58.0863 63.4004 58.9808C63.6108 59.1649 63.6634 59.5858 63.7424 59.7174Z",
    fill: "url(#paint10_linear_1325_202)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0902 31.7265C46.0902 32.4368 46.0902 33.1208 46.0902 33.8311C46.0902 34.7255 45.6167 35.2517 44.7223 35.2517C43.9067 35.2517 43.4332 34.7518 43.4332 33.91C43.4069 32.3842 43.4069 30.8584 43.4332 29.3062C43.4595 28.4644 43.9857 28.0172 44.7749 28.0172C45.5904 28.0435 46.0639 28.517 46.0639 29.3588C46.0902 30.1481 46.0902 30.9373 46.0902 31.7265Z",
    fill: "url(#paint11_linear_1325_202)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0902 67.9515C46.0902 68.6881 46.2744 69.5036 46.0376 70.1613C45.8535 70.6875 45.1958 71.2925 44.696 71.3715C44.3277 71.4241 43.5384 70.6612 43.4858 70.2139C43.328 68.6618 43.4069 67.0834 43.4332 65.505C43.4595 64.6631 44.012 64.1107 44.8012 64.2948C45.301 64.4001 45.9061 65.0051 46.0376 65.505C46.2218 66.2679 46.0902 67.136 46.0902 67.9515Z",
    fill: "url(#paint12_linear_1325_202)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.984 82.0522C48.9577 84.3672 46.9584 86.3403 44.6959 86.2876C42.3809 86.235 40.5131 84.262 40.5394 81.9207C40.5657 79.6582 42.4598 77.8167 44.7749 77.8167C47.1162 77.8167 48.984 79.7108 48.984 82.0522Z",
    fill: "url(#paint13_linear_1325_202)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.984 8.28677C49.0103 10.6281 47.0636 12.5748 44.7486 12.5748C42.4861 12.5748 40.5657 10.6544 40.5394 8.392C40.5131 6.07696 42.3283 4.20915 44.6433 4.18284C47.0636 4.13023 48.9577 5.91912 48.984 8.28677Z",
    fill: "url(#paint14_linear_1325_202)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8158 63.5319C80.8421 65.9259 78.9742 67.8463 76.6329 67.82C74.3705 67.82 72.4501 65.8996 72.3974 63.6371C72.3448 61.2958 74.2389 59.4017 76.6329 59.4017C79.0532 59.428 80.8158 61.1643 80.8158 63.5319Z",
    fill: "url(#paint15_linear_1325_202)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68138 63.6371C8.68138 61.2169 10.365 59.4543 12.759 59.428C15.1793 59.4017 17.0734 61.2169 17.0997 63.5582C17.126 65.8469 15.1266 67.8463 12.8379 67.82C10.5229 67.82 8.70769 65.9785 8.68138 63.6371Z",
    fill: "url(#paint16_linear_1325_202)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8421 26.7544C80.8421 29.0695 79.0006 30.9636 76.7381 31.0162C74.4757 31.0688 72.4501 29.0168 72.4501 26.7544C72.4501 24.4131 74.3968 22.5453 76.7644 22.5716C79.0795 22.5716 80.8421 24.3868 80.8421 26.7544Z",
    fill: "url(#paint17_linear_1325_202)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68138 26.7544C8.68138 24.3868 10.444 22.5716 12.7853 22.5716C15.153 22.5453 17.0997 24.4657 17.0734 26.7807C17.0734 29.0169 15.1266 30.9899 12.8905 31.0425C10.6018 31.0688 8.68138 29.1221 8.68138 26.7544Z",
    fill: "url(#paint18_linear_1325_202)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8798 56.5868C45.8535 56.9025 45.9324 57.2445 45.8272 57.376C45.5115 57.718 45.1169 58.2442 44.7486 58.2179C44.3803 58.2179 43.7752 57.6654 43.7752 57.3234C43.7226 56.6131 43.4069 56.4553 42.8544 56.2711C41.4339 55.7713 40.4605 54.8242 40.0396 53.351C39.8554 52.6933 40.0396 52.1935 40.6709 51.9567C41.3023 51.72 41.7758 51.983 42.0652 52.5881C42.9597 54.4033 44.7486 54.9821 46.5638 54.0876C47.7476 53.5089 47.8528 52.1935 46.6953 51.5358C46.0902 51.1938 45.3536 51.036 44.6696 50.8255C44.0646 50.6414 43.4332 50.5361 42.8544 50.3257C41.2497 49.7206 40.2763 48.4053 40.3027 46.8531C40.3027 45.3799 41.3549 43.9067 42.8281 43.328C43.0912 43.2227 43.3806 43.1175 43.6437 43.0123C43.7752 41.7495 44.1172 41.2234 44.8012 41.2497C45.4852 41.2497 45.8272 41.7758 45.9061 42.986C46.0639 43.0386 46.2481 43.1438 46.4322 43.1964C47.6424 43.5647 48.5105 44.3803 49.0893 45.4852C49.4839 46.2481 49.3523 46.8794 48.721 47.1688C47.9844 47.5108 47.5371 47.1688 47.1688 46.5375C46.3533 45.1169 44.8538 44.617 43.4858 45.4325C43.0123 45.7219 42.5914 46.3533 42.4861 46.8794C42.3546 47.5371 42.9071 48.037 43.5647 48.2474C44.2224 48.4579 44.9064 48.5631 45.5641 48.7736C46.4322 49.0893 47.3267 49.3786 48.0896 49.8522C49.2734 50.6151 49.7469 51.8252 49.5891 53.2195C49.4049 54.7453 48.4053 55.6661 47.0373 56.1922C46.669 56.35 46.3007 56.4553 45.8798 56.5868Z",
    fill: "url(#paint19_linear_1325_202)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1325_202",
    x1: -14.7575,
    y1: 39.9615,
    x2: 89.4972,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6469F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C866AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpe);
export default __webpack_public_path__ + "static/media/cpe.901f028b44b7ca9937d28dd4fd68d1aa.svg";
export { ForwardRef as ReactComponent };